import React from 'react';
import './Policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy">
      <h1 className="policy-heading">Política de Privacidad</h1>

      <h2 className="policy-subheading">1. Introducción</h2>
      <p className="policy-text">
        Bienvenido a la Política de Privacidad de Tu Inquilino Ideal. En Tu Inquilino Ideal, estamos comprometidos a proteger tu privacidad y garantizar la seguridad de tu información personal. Esta Política de Privacidad explica cómo recopilamos, utilizamos y divulgamos tu información personal cuando utilizas nuestro sitio web y servicios inmobiliarios. Al acceder y utilizar nuestro sitio web, consientes las prácticas descritas en esta Política de Privacidad.
      </p>

      <h2 className="policy-subheading">2. Información que Recopilamos</h2>
      <p className="policy-text">
        Podemos recopilar información personal que nos proporciones voluntariamente, como tu nombre, dirección de correo electrónico y detalles de contacto cuando rellenes formularios en nuestro sitio web o te comuniques con nosotros. También recopilamos cierta información no personal automáticamente, incluyendo tu dirección IP, tipo de navegador e información del dispositivo.
      </p>

      <h2 className="policy-subheading">3. Cómo Utilizamos Tu Información</h2>
      <p className="policy-text">
        Utilizamos la información que recopilamos para proporcionar y mejorar nuestros servicios inmobiliarios, responder a tus consultas y comunicarnos contigo sobre nuestros servicios y promociones. También podemos utilizar tu información para analizar tendencias, rastrear el compromiso de los usuarios y recopilar información demográfica para fines internos.
      </p>

      <h2 className="policy-subheading">4. Divulgación de Tu Información</h2>
      <p className="policy-text">
        No vendemos, intercambiamos ni transferimos de otra manera tu información personal a terceros sin tu consentimiento. Sin embargo, podemos compartir tu información con proveedores de servicios de terceros de confianza que nos ayudan a operar nuestro sitio web y proporcionar nuestros servicios inmobiliarios. También podemos divulgar tu información cuando lo requiera la ley o para proteger nuestros derechos, seguridad o propiedad.
      </p>

      <h2 className="policy-subheading">5. Seguridad de los Datos</h2>
      <p className="policy-text">
        Implementamos medidas de seguridad razonables para proteger tu información personal contra el acceso y uso no autorizados. Sin embargo, ningún método de transmisión por internet o almacenamiento electrónico es completamente seguro, y no podemos garantizar la seguridad absoluta de tu información.
      </p>

      <h2 className="policy-subheading">6. Tus Opciones</h2>
      <p className="policy-text">
        Tienes el derecho de revisar, actualizar y corregir tu información personal contactándonos. También puedes optar por no recibir comunicaciones de marketing de nosotros en cualquier momento siguiendo las instrucciones de cancelación de suscripción incluidas en nuestros correos electrónicos.
      </p>

      <h2 className="policy-subheading">7. Cambios a la Política de Privacidad</h2>
      <p className="policy-text">
        Podemos actualizar esta Política de Privacidad de vez en cuando para reflejar cambios en nuestras prácticas o por otras razones operativas, legales o regulatorias. Te notificaremos de cualquier cambio material publicando la Política de Privacidad actualizada en nuestro sitio web.
      </p>

      <h2 className="policy-subheading">8. Contáctanos</h2>
      <p className="policy-text">
        Si tienes alguna pregunta o preocupación sobre nuestra Política de Privacidad, por favor contáctanos en info@tuinquilinoideal.es.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
